import { render } from "./modal_dossier_medical.vue?vue&type=template&id=92d146f0"
import script from "./modal_dossier_medical.vue?vue&type=script&lang=js"
export * from "./modal_dossier_medical.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__